module.exports = __webpack_public_path__ + "static/media/alarm.6fe4a3f9.mp3";